const key = 'CLIENT__';

exports.SET_CREATE_EDIT_CLIENT = `${key}SET_CREATE_EDIT_CLIENT`;
exports.SET_CLIENT_ID_TO_EDIT = `${key}SET_CLIENT_ID_TO_EDIT`;
exports.SET_VIEW_CLIENT = `${key}SET_VIEW_CLIENT`;
exports.SET_DASHBOARD_CLIENT = `${key}SET_DASHBOARD_CLIENT`;
